import printHtml from '@/mixins/printHtml'

const productionBlendingPrintBlend = {
  mixins: [printHtml],
  methods: {
    async printBlend(id, formula, print) {
      const isFormula = !!formula;
      const results =  await this.$apiCall(`query productionBlendingPrintBlend($id:ID!, $isFormula:Boolean!, $audit:Boolean!) {
                                              formula(id:$id) @include(if:$isFormula) {
                                                name,description
                                                outputName,excise
                                                scaleBase,scaleToId
                                                blendToVolume,blendStrength
                                                inputs {type,id,itemName,quantity,minQuantity,maxQuantity,precision,itemUnits,strength}
                                              }
                                              blend(id:$id) @skip(if:$isFormula) {
                                                date,duration,siteName,completed
                                                formulaName,comments
                                                outputName,tankName
                                                volume,litres,lot,excise
                                                blendToVolume,blendStrength
                                                inputs {type,typeName,lot,vesselName,quantity,precision,units,laa,strength}
                                                audit @include(if:$audit) {userName,time,event}
                                              }
                                              blendingPreferences {
                                                blendDuration
                                              }
                                          }`,
                                          {id, isFormula, audit:this.$store.getters.company.allowAudit});
      if (results.error)
        return;

      const blend = isFormula ? results.data.formula : results.data.blend;
      const preferences = results.data.blendingPreferences;

      if (isFormula && formula.quantity !== undefined) {
        let scaleFactor = 1;
        for (const input of blend.inputs || []) {
          let q;
          if (input.type === 'Spirit' || input.type === 'Wine') {
            q = this.$roundNumber(formula.quantity * input.quantity / 100, 3);
            if (input.id === blend.scaleToId)
              scaleFactor = q / blend.scaleBase;
          }
          else
            q = input.quantity * scaleFactor;
          input.quantity = q;
        }
      }

      const lines = [`
        <style>
          @page {size:portrait}
          table {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px;table-layout:fixed}
          td {padding:5px;height:30px;position:relative}
          .title {font-weight:bold;text-align:center;font-size:150%;padding-bottom:40px}
          .subtitle {font-weight:medium;text-align:center;height:10px}
          .box {${isFormula ? 'border-bottom:thin solid #aaa':''}}
          .label {display:inline-block;top:-8px;position:absolute;xbackground-color:#fff;xpadding-left:5px;xpadding-right:5px;font-size:90%}
          .suffix {display:inline-block${isFormula ? ';float:right' : ''}}
          .placeholder {${isFormula ? 'color:#888' : ''}}
          .half-line {height:20px}
          .hint {text-align:center; font-size:9px}
          .inner-table {border:thin solid #ccc; padding:10px}
          .page-break {page-break-before: always;}
          .incomplete {font-size:50px;opacity:0.2;text-align:center}
        </style>
        <table>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <thead>
            ${isFormula || blend.completed ? '' : `<tr><td colspan="20" class="incomplete">INCOMPLETE</td></tr>`}
            <tr><td colspan="20" class="subtitle">${this.company.name}</td></tr>
            <tr><td colspan="20" class="title">Blend</td></tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="5" class="box"><div class="label">Date</div>
                <span class="placeholder">
                  ${isFormula?`${formula.date ? this.$formatDateTime(formula.date) : ''}`:this.$formatDateTime(blend.date)}
                </span>
              </td>
              <td/>
              ${preferences.blendDuration ? `<td colspan="4" class="box"><div class="label">Duration</div>${isFormula?'':this.$options.filters.duration(blend.duration)}</td>` : '<td colspan="4"/>'}
              <td colspan="4"/>
              ${this.$store.getters.sites(true, {B266:true}).length ? `<td colspan="6" class="box"><div class="label">Site</div>
                ${isFormula?formula.siteName??'':blend.siteName}
              </td>` : '<td colspan="6"/>'}
            </tr>
            <tr><td colspan="20"/></tr>
            <tr>
              <td colspan="5" class="box"><div class="label">Formula</div>${isFormula?blend.name:blend.formulaName||'Ad hoc'}</td>
            </tr>
            ${blend.description ? `<tr><td colspan="10">${blend.description}</td></tr><tr><td colspan="20" class="half-line"/></tr>` : '<tr><td colspan="20"/></tr>'}
            <tr>
              <td colspan="5" class="box"><div class="label">Blend to produce</div>${blend.outputName}</td>
              <td colspan="1"/>
              <td colspan="5" class="box"><div class="label">Destination tank</div>${isFormula?'':blend.tankName}</td>
              <td colspan="1"/>
              ${!isFormula && blend.excise === 'SpiritsReductionBulkSpiritsReturnedToSpiritProduction'?`<td colspan="3" class="box"><div class="label">LAA</div>${this.$number(blend.volume,3)}</td>`:''}
              ${isFormula && blend.excise === 'SpiritsReductionBulkSpiritsReturnedToSpiritProduction'?`<td colspan="3" class="box"><div class="label">LAA</div><div class="placeholder">${this.$number(formula.quantity,3)}</div></td>`:''}
            </tr>
            <tr><td colspan="20"/></tr>
            <tr>
              ${isFormula?'':`<td colspan="5" class="box"><div class="label">Lot</div>${blend.lot}</td>`}
              ${!isFormula?`<td/>`:''}
              ${blend.excise !== 'SpiritsReductionBulkSpiritsReturnedToSpiritProduction' || blend.blendToVolume
                  ? `<td colspan="5" class="box">
                       <div class="label">Volume</div>
                       ${isFormula?'':this.$number(blend.litres,3)}
                       <div class="suffix">
                         litres
                         ${blend.blendToVolume && blend.excise === 'SpiritsReductionBulkSpiritsReturnedToSpiritProduction'
                            ? ` @ ${this.$number(blend.blendStrength)}% alc./vol.`
                            : ``
                         }
                       </div>
                     </td>`
                  :''
                }
            </tr>
            <tr><td colspan="20" class="half-line"/></tr>

            <tr>
              <td colspan="20" class="inner-table">
                <table>

            <tr>
              <td colspan="8" class="half-line"><strong>Input</strong></td>
              <td/>
              <td colspan="4" class="half-line"><strong>Tank or Lot</strong></td>
              <td/>
              <td colspan="6" class="half-line"><strong>Quantity</strong></td>
            </tr>
        `];

      for (const item of blend.inputs) {
        lines.push(`
          <tr>
            <td colspan="8" class="box">${isFormula?item.itemName:item.typeName}</td>
            <td/>
            <td colspan="4" class="box">${isFormula?'':(item.type !== 'Item' ? item.vesselName:item.lot ?? '')}</td>
            <td/>
            <td colspan="6" class="box">
              ${item.type === 'Spirit' || item.type === 'Wine' || item.type === 'NonExcise'
                  ? `${isFormula
                        ? (blend.blendToVolume ? `` : `${formula.quantity !== undefined ? `<span class="placeholder">${this.$number(item.quantity,3)}</span>` : ''}`)
                        : (blend.blendToVolume ? this.$number(item.quantity,3) : this.$number(item.laa,3))
                      }`
                  : `${/*isFormula ? `` :*/ `<span class="${item.minQuantity !== item.quantity || item.maxQuantity !== item.quantity ? 'placeholder' : ''}">${this.$number(item.quantity, item.precision)}</span>`}`
              }
              <div class="suffix">
                ${blend.blendToVolume && (item.type === 'Spirit' || item.type === 'Wine' || item.type === 'NonExcise')
                    ? `litres @ ${this.$number(item.strength,2)}% alc./vol.`
                    : (isFormula ? item.itemUnits : item.units)
                }
              </div>
            </td>
          </tr>`);
        if (isFormula && blend.blendToVolume)
          lines.push(`
          <tr>
            <td colspan="14" class="half-line"/>
            <td colspan="6" class="half-line hint">
              ${this.$number(item.quantity, item.precision)} per litre
            </td>
          </tr>
        `);
        if (isFormula && !blend.blendToVolume)
          lines.push(`
          <tr>
            <td colspan="14" class="half-line"/>
            <td colspan="6" class="half-line hint">
              ${item.type === 'Spirit' || item.type === 'Wine' || item.type === 'NonExcise'
                ? `${this.$number(item.quantity,1)}%`
                : item.minQuantity === item.quantity && item.maxQuantity === item.quantity
                    ? ''
                    : `${item.maxQuantity ? 'Must be ' : 'Must be'}
                      ${item.minQuantity ? `>= ${this.$number(item.minQuantity, item.precision)}` : `>= ${this.$number(item.minQuantity, item.precision)}`}
                      ${item.maxQuantity && item.maxQuantity ? ' and ' : ''}
                      ${item.maxQuantity ? `<= ${this.$number(item.maxQuantity, item.precision)}` : ''}`
              }
            </td>
          </tr>
        `);
      }
      if (isFormula)
        lines.push(`
          <tr>
            <td colspan="8" class="box"></td>
            <td/>
            <td colspan="4" class="box"></td>
            <td/>
            <td colspan="6" class="box"></td>
          </tr>`);
      lines.push(`
          </table>
      </td>
    </tr>

        <tr><td/></tr>
        <tr>
          <td colspan="20" class="box" style="height:60px"><div class="label">Comments</div>
          ${isFormula?'':blend.comments}
          </td>
        </tr>`);

      if (isFormula)
        lines.push(`
        <tr><td/></tr>
        <tr><td/></tr>
        <tr>
          <td colspan="8" class="box"><div class="label">Performed by</div><div class="placeholder">${formula.performBy}</div></td>
          <td/>
          <td colspan="8" class="box"><div class="label">Signature</div></td>
        </tr>`);

      else if (this.$store.getters.company.allowAudit) {
        lines.push(`<tr>
                      <td colspan="4"><strong>Date</strong></td>
                      <td/>
                      <td colspan="5"><strong>User</strong></td>
                      <td/>
                      <td colspan="9"><strong>Action</strong></td>
                    </tr>`);
        for (const audit of blend.audit)
          lines.push(`<tr>
                        <td colspan="4">${this.$formatDateTime(audit.time)}</td>
                        <td/>
                        <td colspan="5">${audit.userName}</td>
                        <td/>
                        <td colspan="9">${audit.event}</td>
                      </tr>`);
      }

      lines.push(`
        </tbody>
        </table>
      `);

      if (print)
        this.printHtml('Blend',lines.join(''));
      else
        return lines;
    }
  }
}

export default productionBlendingPrintBlend;